import React from "react";
import PropTypes from "prop-types";

import DialogFormWithMutation from "dialogs/DialogFormWithMutation";
import AddEditUserFields from "./AddEditUserFields";
import Alert from "ui/Alert";
import DialogForm from "ui/Dialog";
import Button from "ui/Button";

import useAddUserDialogFields from "hooks/system/useAddUserDialogFields";

import { addUserValidator } from "validators/addUserValidator";

import {
  CREATE_USER_MUTATION,
  GET_USERS_QUERY_NAME,
} from "graphqlQueries/system";

const initialValues = {
  email: "",
  username: "",
  password: "",
  confirm_password: "",
  first_name: "",
  last_name: "",
  groupname: "",
};

const fieldsWithPlaceForError = [
  "email",
  "username",
  "password",
  "first_name",
  "last_name",
  "groupname",
];

const AddUserDialog = (props) => {
  const { loading, roleNames } = useAddUserDialogFields();

  if (!roleNames.length) {
    const renderButtons = (onClose) => {
      return (
        <Button
          id="close-add-user-dialog-button"
          variant="text"
          onClick={onClose}
          color="primary"
        >
          Close
        </Button>
      );
    };

    return (
      <DialogForm
        renderActionsFunc={renderButtons}
        isLoading={loading}
        preLoading={loading}
        preLoadingHeight="60px"
        className="dialog-default-width"
        title="New user"
        {...props}
      >
        <Alert
          variant="filled"
          severity="error"
          text="There are no roles yet, add role at first"
        />
      </DialogForm>
    );
  }

  return (
    <DialogFormWithMutation
      mutationQueries={CREATE_USER_MUTATION}
      refetchQueries={[GET_USERS_QUERY_NAME]}
      initialValues={initialValues}
      validationSchema={addUserValidator}
      fieldsWithPlaceForError={fieldsWithPlaceForError}
      title="New user"
      submitButtonName="Save"
      className="dialog-default-width"
      disableSubmit={loading}
      {...props}
    >
      <AddEditUserFields loading={loading} roleNames={roleNames} />
    </DialogFormWithMutation>
  );
};

AddUserDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default AddUserDialog;
